import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ComponentEditService {
    constructor(
        private http: HttpService,
    ) {
    }

    getHelpMetaData(helpId: string, su: string): Observable<any> {
        const url = `/api/runtime/lcm/v1.0/rt-metadatas/${helpId}`;
        return this.http.get(url);
    }
}
